import React, { memo } from 'react';
import MypageReturn from '../molecules/MypageReturn';
import Paragraph from '../molecules/Paragraph';

interface Props {
  mypage_opened: boolean; // マイページ開設状態
  is_login: boolean; // ログイン中フラグ
}

// KWANKGM03040_事前審査結果確認フッタボタン
const FooterPreliminaryExaminationResultConfirmationDisapproval: React.FC<Props> = ({
  mypage_opened,
  is_login,
}) => {
  // マイページへ戻るボタンの表示
  const visibleMypageReturn = () => {
    if (mypage_opened && is_login) {
      return <MypageReturn is_staff={false} />;
    }
    return (
      <Paragraph
        label="本ページを閉じる場合はウィンドウまたはタブを閉じて下さい。"
        is_paragraph={false}
      />
    );
  };
  return visibleMypageReturn();
};

export default memo(FooterPreliminaryExaminationResultConfirmationDisapproval);
